import "./icons"
import { init, domReady } from "./utils"
import store from "./store"
import lazyload from "./modules/lazyload"
import header from "./modules/header"
import projectSticky from "./modules/project-sticky"
import sliders from "./modules/sliders"
import management from "./modules/management"

domReady(() => {
  store.dispatch({
    type: "UPDATE_SNIFFER",
    payload: {
      isTouch: !!("ontouchstart" in document.documentElement),
      isIE11:
        navigator.userAgent.indexOf("MSIE") !== -1 ||
        navigator.appVersion.indexOf("Trident/") > -1,
      isEdge: window.navigator.userAgent.indexOf("Edge") > -1,
      passiveListeners: (() => {
        let passiveSupported = false

        try {
          window.addEventListener(
            "test",
            null,
            Object.defineProperty({}, "passive", {
              get: () => (passiveSupported = true),
            }),
          )
        } catch (err) {}

        return passiveSupported
      })(),
    },
  })

  init({
    lazyload,
    header,
    projectSticky,
    sliders,
    management,
  })
})
